import { useState } from 'react';
import { ImSpinner10 } from 'react-icons/im';
import { FiRefreshCw } from 'react-icons/fi';

export default function NewVersionModal() {
  const [reloading, setReloading] = useState(false);

  const handleReload = () => {
    setReloading(true);
    // Força una recàrrega sense caché
    window.location.href = window.location.href.split('#')[0] + '?_v=' + Date.now();
  };

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/70 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 border-2 border-indigo-800">
        <div className="flex items-center gap-3 mb-4">
          <FiRefreshCw className="text-indigo-800 flex-shrink-0" size={28} />
          <h2 className="text-lg font-bold text-indigo-900">
            Nova versió disponible
          </h2>
        </div>

        <p className="text-sm text-gray-700 mb-2">
          S&apos;ha publicat una nova versió del programa amb millores i noves validacions.
        </p>
        <p className="text-sm text-gray-700 mb-6">
          Cal recarregar la pàgina per continuar treballant amb la versió actualitzada.
          Els canvis que estigueu editant sense guardar es perdran.
        </p>

        <button
          onClick={handleReload}
          disabled={reloading}
          className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-indigo-800 text-white font-semibold rounded hover:bg-indigo-900 transition-colors disabled:opacity-50"
        >
          {reloading ? (
            <>
              <ImSpinner10 size={20} className="animate-spin" />
              Recarregant...
            </>
          ) : (
            <>
              <FiRefreshCw size={20} />
              Recarregar ara
            </>
          )}
        </button>
      </div>
    </div>
  );
}